const senserRoutes = [
  {
    path: '',
    component: () => import('@/app/shared/layouts/main/Main.vue'),
    children: [
      // =============================================================================
      // PAGES
      // =============================================================================
      {
        path: '/senser/explore',
        name: 'senserExplore',
        component: () => import('./views/Senser.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'senser' },
            { title: 'explore', active: true },
          ],
          pageTitle: 'Explore',
          rule: 'editor'
        }
      },
      {
        path: '/senser/dashboard',
        name: 'senserDashboard',
        component: () => import('./views/Mock.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'paper-demo' },
            { title: 'dashboard', active: true }
          ],
          pageTitle: 'Dashboard',
          rule: 'editor'
        }
      },
      {
        path: '/senser/demfor',
        name: 'senserDemfor',
        component: () => import('./views/Demfor.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'paper-demo' },
            { title: 'dem-for', active: true }
          ],
          pageTitle: 'Demfor',
          rule: 'editor'
        }
      },
    ]
  }
];

export default senserRoutes;
